import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import ApiCustom from "../../utils/ApiCustom";
import { useNavigate } from "react-router-dom";

import { loginFailure } from "../../features/authSlice";
import { toast } from "react-toastify";

const AuthCallback = () => {
  const [searchParams] = useSearchParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const hasCalled = useRef(false);

  useEffect(() => {
    const code = searchParams.get("code");
    if (!hasCalled.current) {
      if (code) {
        loginOAuthGoogle(code);
      }
      hasCalled.current = true;
    }
  }, []);

  const loginOAuthGoogle = async (code) => {
    ApiCustom.post(
      "/login/oauth/google",
      { code },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((response) => {
        localStorage.setItem("access_token_bccu", response.data?.data?.token);
        localStorage.setItem("full_name", response.data?.data?.userFullName);
        localStorage.setItem("type_user", response.data?.data?.type);
        localStorage.setItem("userId", response.data?.data?.id);
        localStorage.setItem("userEmail", response.data?.data?.userEmail);
        localStorage.setItem("userPhone", response.data?.data?.userPhone);
        localStorage.setItem(
          "companyId",
          response.data?.data?.companies?.find(
            (e) => e?.CompaniesHasUsers?.isUserRepresentOfCompany
          )?.id || null
        );
        localStorage.setItem(
          "permissions",
          JSON.stringify(response.data?.data?.role?.permissions || [])
        );
        if (response.data?.data?.type === "admin")
          window.location.href = "/admin/dashboard";
        else window.location.href = "/";
      })
      .catch((error) => {
        navigate("/login");
        dispatch(
          loginFailure(error.response?.data?.messages || "Đăng nhập thất bại")
        );
      })
      .finally(() => {});
  };

  return (
    <p className="text-center text-gray-500 mt-10">Đang xử lý đăng nhập...</p>
  );
};

export default AuthCallback;
